import { useOutletContext } from 'react-router-dom'

import { Box, Prose } from '@factorialco/deprecated-design-system'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import RoleEmployeesTable from 'modules/job_catalog/components/RoleEmployeesTable'
import SalaryInsights from 'modules/job_catalog/components/SalaryInsights'
import type { Role } from 'modules/job_catalog/hooks/useRole'
import { RoleTabs } from 'modules/job_catalog/pages/Role/RoleTabs'

interface OutletContext {
  role: Role
  canEditRole: boolean
  isLoading: boolean
}

const Component = () => {
  const { role } = useOutletContext<OutletContext>()

  return (
    <Box width="full" gap="s24">
      {role?.description && (
        <Box paddingBottom="s64">
          <Prose fullWidth>
            <div dangerouslySetInnerHTML={{ __html: role?.description }} />
          </Prose>
        </Box>
      )}
      <RoleTabs roleId={role.id} />
      <SalaryInsights role={role} contractVersions={contractVersions} />
      <RoleEmployeesTable role={role} contractVersions={contractVersions} />
    </Box>
  )
}

export default Component
